import {LocalizationProvider} from '@mui/lab';
import {ModalProvider} from '@liholiho/react-modal-hook';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import BlockPageLoader from 'common/components/BlockPageLoader';
import GlobalBanner from 'common/components/GlobalBanner/GlobalBanner';
import {createBrowserHistory} from 'history';
import React, {lazy, Suspense} from 'react';
import {useTranslation} from 'react-i18next';
import {Router} from 'react-router-dom';
import enLocale from 'date-fns/locale/en-GB';
import ruLocale from 'date-fns/locale/ru';
import Cookies from 'js-cookie';
import {FROV_SIGN} from 'common/constants';
import {EFrovSign} from 'common/types';
import getTheme from '../common/theme/getTheme';
import {ThemeProvider} from '@mui/material';

// eslint-disable-next-line react-refresh/only-export-components
export const history = createBrowserHistory();

const AuthRoutes = lazy(() => import('./AuthRoutes'));
const FrovRoutes = lazy(() => import('./FrovRoutes'));
const NonFrovRoutes = lazy(() => import('./NonfrovRoutes'));

const AppRouter: React.FC = () => {
  const frovsign = Cookies.get(FROV_SIGN);
  const {i18n} = useTranslation();

  const locale = React.useMemo(() => (i18n.language === 'ru' ? ruLocale : enLocale), [i18n.language]);

  React.useEffect(() => {
    const currentLng: string | null = localStorage.getItem(`language`);
    i18n.changeLanguage(currentLng || 'ru');
  }, [i18n, i18n.language]);

  return (
    <ThemeProvider theme={getTheme(frovsign as EFrovSign)}>
      {frovsign === EFrovSign.frov && <GlobalBanner />}
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
        <ModalProvider>
          <Suspense fallback={<BlockPageLoader />}>
            <Router history={history}>
              {!frovsign && <AuthRoutes />}
              {frovsign === EFrovSign.frov && <FrovRoutes />}
              {frovsign === EFrovSign.nonfrov && <NonFrovRoutes />}
            </Router>
          </Suspense>
        </ModalProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default AppRouter;
